<template>
  <v-dialog
    class="select-content-dialog"
    title="Select Content"
    :visible.sync="dialogVisible"
    width="auto"
    @open="onOpen"
    @closed="onClosed"
  >
    <div class="padding-lr">
      <PageHeader :line="false">
        <el-input
          prefix-icon="el-icon-search"
          placeholder="Search"
          v-model="searchVal"
          v-debounce="onSearch"
          clearable
          @clear="onSearch"
        >
        </el-input>
      </PageHeader>
      <el-table
        :data="tableData"
        ref="table"
        height="50vh"
        @select="handleSelect"
        @select-all="handleSelectionAll"
        @sort-change="onSortChange"
        v-loading="tableLoading"
        element-loading-text="Loading..."
      >
        <el-table-column
          type="selection"
          width="45"
          align="center"
          :selectable="selectableHandler"
        />
        <el-table-column
          prop="Content"
          label="Content"
          sortable="custom"
          min-width="140"
        >
        <template #default="{ row }">
            <a :href="row.AttachmentPath" target="_blank">{{ row.Content }}</a>
          </template>
        </el-table-column>
        <el-table-column
          prop="Category"
          label="Category"
          sortable="custom"
          min-width="140"
        />
        <el-table-column
          prop="SecurityLevel"
          label="Security Level"
          sortable="custom"
          min-width="140"
        />        
        <el-table-column
          prop="CreatedDate"
          label="Create Date"
          sortable="custom"
          width="140"
        />
      </el-table>
      <div class="pagination-wrap">
        <div class="actions">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 25, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          />
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        @click="onConfirm"
        :disabled="multipleSelection.length === 0"
      >
        Select
      </el-button>
    </div>
  </v-dialog>
</template>
<script>
export default {
  name: "select-content-dialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    selected: Array,
    categoried: Number,
    paperContent: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      searchVal: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      orderBy: "CreatedDate",
      orderType: "descending",
      dialogVisible: this.visible,
      tableData: [],
      tableLoading: false,
      multipleSelection: [],
    };
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
    categoried() {
      this.resetToFirstPage();
    },
  },
  methods: {
    resetToFirstPage() {
      this.searchVal = "";
      this.currentPage = 1;
      this.pageSize = 10;
      this.orderBy = "CreatedDate";
      this.orderType = "descending";
      const table = this.$refs.table;
      if (table) {
        table.clearSort();
      }
    },
    getTableData() {
      this.tableLoading = true;
      let params = {
        pageSize: this.pageSize,
        page: this.currentPage,
        orderBy: this.orderBy,
        orderType: this.orderType,
        key: this.searchVal,
        // categoried: this.categoried,
      };
      this.axios
        .get(`/combinePush/paperList`, {
          params: params,
        })
        .then(({ code, data, msg }) => {
          if (200 === code) {
            this.total = data.total;
            this.tableData = data.data;
            this.toggleRowSelection();
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getTableData();
    },
    onSortChange(column) {
      this.orderBy = column.prop;
      this.orderType = column.order;
      this.getTableData();
    },
    onSearch() {
      this.currentPage = 1;
      this.getTableData();
    },
    onOpen() {
      this.getTableData();
      this.multipleSelection = [].concat(this.selected);
      console.log('multipleSelection',this.multipleSelection)
    },
    onClosed() {
      this.multipleSelection = [];
      this.$emit("update:visible", false);
      this.$emit("closed");
    },
    selectableHandler(row) {
      return !this.selected.some((i) => i.PaperID === row.PaperID);
    },
    handleSelect(selection, row) {
      let index = this.multipleSelection.findIndex(
        (i) => i.PaperID === row.PaperID
      );
      if (index === -1) {
        this.multipleSelection.push(row);
      } else {
        this.multipleSelection.splice(index, 1);
      }
    },
    handleSelectionAll(select) {
      if (select.length > 0) {
        let result = select.filter((x) => {
          return !this.multipleSelection.some((y) => y.PaperID === x.PaperID);
        });
        this.multipleSelection = this.multipleSelection.concat(result);
      } else {
        let rows = this.tableData.filter((x) => {
          return this.multipleSelection.some((y) => y.PaperID === x.PaperID);
        });
        let result = this.multipleSelection.filter((x) => {
          return !rows.some((y) => y === x);
        });
        this.multipleSelection = result;
      }
    },
    toggleRowSelection() {
      let rows = this.tableData.filter((x) => {
        return this.multipleSelection.some((y) => y.PaperID === x.PaperID);
      });
      rows.forEach((row) => {
        this.$nextTick(() => {
          this.$refs.table.toggleRowSelection(row, true);
        });
      });
    },
    filterSelected() {
      return this.multipleSelection.filter((i) => {
        return !this.selected.some((j) => i.PaperID === j.PaperID);
      });
    },
    hasFilesChanged() {
      // 检查当前选择的文件是否与已有文件不同
      if (this.selected.length === 0) {
        return false;
      }
      
      const currentSelectionIds = this.multipleSelection.map(item => item.PaperID).sort();
      const existingSelectionIds = this.selected.map(item => item.PaperID).sort();
      
      // 比较两个数组是否相同
      if (currentSelectionIds.length !== existingSelectionIds.length) {
        return true;
      }
      
      return !currentSelectionIds.every((id, index) => id === existingSelectionIds[index]);
    },
    onConfirm() {
      // 检查 Description 是否有值
      if (this.paperContent && this.paperContent.trim() !== '') {
        // Description 有值，弹出确认提示
        this.$confirm('调整文件后，现有Description将清空，进行重新加载', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 用户确认，执行选择操作并触发清空Description事件
          this.performConfirm();
          this.$emit("clear-description");
        }).catch(() => {
          // 用户取消，不关闭弹窗，不执行任何操作
        });
      } else {
        // Description 为空，直接执行选择操作
        this.performConfirm();
      }
    },
    performConfirm() {
      const selected = this.filterSelected();
      this.dialogVisible = false;
      this.$emit("select", selected);
    },
  },
};
</script>
<style lang="scss" scoped>
.select-content-dialog {
  ::v-deep .el-dialog__body {
    padding-top: 10px;
  }
}

::v-deep {
  .el-dialog__body {
    display: flex;
    max-height: 67vh;
  }
}
.dialog-footer {
  text-align: center;
}
</style>
